import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import Layout from '@/components/Layout';
import { toast } from '@/hooks/use-toast';

const EmailConfirmation = () => {
  console.log('EmailConfirmation component mounted');
  const [searchParams] = useSearchParams();
  console.log('Search params:', Object.fromEntries(searchParams.entries()));
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isConfirmed, setIsConfirmed] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        const token_hash = searchParams.get('token_hash');
        const type = searchParams.get('type');
        const apikey = searchParams.get('apikey');

        if (!token_hash || !type) {
          setError('Invalid confirmation link. Missing required parameters.');
          setIsLoading(false);
          return;
        }

        console.log('Confirming email with params:', { token_hash, type });

        // Create a Supabase client with the API key from the URL
        const supabaseUrl = "https://hidccmqapkiyczyleerr.supabase.co";
        const supabaseKey = apikey || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhpZGNjbXFhcGtpeWN6eWxlZXJyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyODA5MDcsImV4cCI6MjA1OTg1NjkwN30.LAc4BSSEdGjt5YwMnF7Y5aZO8Z48fCw_m_vtNFlhWKI";
        
        const supabaseClient = createClient(supabaseUrl, supabaseKey);

        const { error } = await supabaseClient.auth.verifyOtp({
          token_hash,
          type: type as any,
        });

        if (error) {
          console.error('Email confirmation error:', error);
          setError(error.message);
        } else {
          setIsConfirmed(true);
          toast({
            title: "Email confirmed!",
            description: "Your email has been successfully verified.",
          });
          
          // Redirect to profile after a delay
          setTimeout(() => {
            navigate('/profile');
          }, 2000);
        }
      } catch (err) {
        console.error('Unexpected error:', err);
        setError('An unexpected error occurred during email confirmation.');
      } finally {
        setIsLoading(false);
      }
    };

    confirmEmail();
  }, [searchParams, navigate]);

  const handleReturnToProfile = () => {
    navigate('/profile');
  };

  return (
    <Layout>
      <div className="min-h-screen flex items-center justify-center px-4">
        <Card className="w-full max-w-md">
          <CardHeader className="text-center">
            <CardTitle>Email Confirmation</CardTitle>
            <CardDescription>
              {isLoading ? "Confirming your email..." : "Email confirmation status"}
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            {isLoading && (
              <div className="text-center">
                <p>Processing your email confirmation...</p>
              </div>
            )}
            
            {!isLoading && isConfirmed && (
              <div className="text-center space-y-4">
                <p className="text-green-600">✅ Your email has been successfully confirmed!</p>
                <p>You will be redirected to your profile shortly.</p>
                <Button onClick={handleReturnToProfile} className="w-full">
                  Go to Profile
                </Button>
              </div>
            )}
            
            {!isLoading && error && (
              <div className="text-center space-y-4">
                <p className="text-red-600">❌ {error}</p>
                <Button onClick={handleReturnToProfile} variant="outline" className="w-full">
                  Return to Profile
                </Button>
              </div>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default EmailConfirmation;